import { Blocks, Bolt, Dog, Flame, Goal, Lock, RailSymbol, Rocket, Subtitles, Trash2 } from "lucide-react";

// HeroShownPure.jsx
export default function HeroCard14() {
  return (
    <>
      <section className="shown-hero" aria-labelledby="shown-hero-title">
        {/* subtle background textures / particles */}
        <div className="bg-fog fog1" aria-hidden></div>
        <div className="bg-fog fog2" aria-hidden></div>
        <svg className="bg-dots" width="100%" height="100%" viewBox="0 0 800 600" preserveAspectRatio="none" aria-hidden>
          <defs>
            <pattern id="p" width="28" height="28" patternUnits="userSpaceOnUse">
              <circle cx="2" cy="2" r="1.2" fill="rgba(0,0,0,0.03)"></circle>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#p)"></rect>
        </svg>

        <div className="shown-inner">

          {/* LEFT: heading / copy */}
          <div className="shown-left">
            <h1 id="shown-hero-title" className="shown-title">
              No experience or <br/> big budget needed
            </h1>

            <p className="shown-sub">
              New to online advertising? Learn how Shown helps you reach your advertising goals without the high costs of traditional solutions.
            </p>

            <div className="shown-cta">
              <button className="btn-primary">Get Started</button>
            </div>
          </div>

          {/* RIGHT: social column, central app icon, animated UI card-c14s */}
          <div className="shown-right" aria-hidden>

            {/* vertical social icons column */}
            <div className="social-col" aria-hidden>
              <div className="social-pill">
                <Blocks size={30} className="" />
              </div>
              <div className="social-pill">
                <Subtitles size={30} className="" />
              </div>
              <div className="social-pill">
                <Rocket size={30} className="" />
              </div>
              <div className="social-pill">
               <RailSymbol size={30} className="" />
              </div>
              <div className="social-pill">
               <Goal size={30} className="" />
              </div>
            </div>

            {/* central glowing app icon */}
           

            {/* animated UI card-c14s stack */}
            <div className="card-c14s-wrap" aria-hidden>

              {/* Card A */}
              <div className="ui-card-c14 card-c14-a glass " style={{"--d":"0s"}}>
                <div className="card-c14-meta">
                  <div className="chip">Campaign A</div>
                  <div className="mini-chart"> <Lock size={30} className="" /></div>
                </div>
                <div className="card-c14-body">
                  <h4>Campaign A</h4>
                  <p className="muted">Top performing audience</p>
                </div>
                <div className="card-c14-cta">See performances</div>
              </div>

              {/* Card B */}
              <div className="ui-card-c14 card-c14-b glass float-slow " style={{"--d":"0.18s"}}>
                <div className="card-c14-meta">
                  <div className="chip">Campaign B</div>
                  <div className="mini-chart"> <Trash2 size={30} className="" /></div>
                </div>
                <div className="card-c14-body">
                  <h4>Campaign B</h4>
                  <p className="muted">A/B tested creatives</p>
                </div>
                <div className="card-c14-cta">See performances</div>
              </div>

              {/* Card C */}
              <div className="ui-card-c14 card-c14-c glass float-long " style={{"--d":"0.36s"}}>
                <div className="card-c14-meta">
                  <div className="chip">Campaign C</div>
                  <div className="mini-chart"> <Flame size={30} className="" /></div>
                </div>
                <div className="card-c14-body">
                  <h4>Campaign C</h4>
                  <p className="muted">Automated optimization</p>
                </div>
                <div className="card-c14-cta">See performances</div>
              </div>

            </div>

            {/* decorative thin connector between social col and app center */}
            <div className="connector" aria-hidden></div>

          </div>
        </div>

        {/* Embedded CSS */}
        <style>{`
/* ---------------------------
   Hero: Shown-like (Pure CSS)
   Option D: Slide-in + float + glass + shine + tilt
   --------------------------- */
:root{
  --accent: #5b8cff;
  --glass-bg: rgba(255,255,255,0.55);
  --glass-border: rgba(255,255,255,0.6);
  --muted: #7a8691;
  --card-c14-w: 260px;
}

/* section */
.shown-hero {
  position: relative;
  overflow: hidden;
  padding: 72px 0 120px;
  background: linear-gradient(180deg,#fbfdff 0%, #f6f9fc 45%, #ffffff 100%);
  color: #0d1b23;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
}

/* subtle background fog */
.bg-fog { position:absolute; filter: blur(48px); opacity: .55; pointer-events:none; z-index:0; }
.fog1 { width:520px; height:520px; left:4%; top:-5%; background: radial-gradient(circle at 30% 30%, #eaf6ff 0%, transparent 45%); }
.fog2 { width:420px; height:420px; right:6%; bottom:-12%; background: radial-gradient(circle at 70% 70%, #fff0f7 0%, transparent 45%); }
.bg-dots { position:absolute; inset:0; opacity: .12; z-index:0; pointer-events:none; }

/* layout grid */
.shown-inner {
  width:92%;
  max-width:1280px;
  margin:0 auto;
  display:grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items:center;
  position:relative;
  z-index:3;
}

/* LEFT content */
.shown-left { padding-left: 20px; }
.shown-title {
  font-size:52px;
  line-height:1.02;
  margin:0 0 18px;
  font-weight:800;
  color:#0b1b22;
}
.shown-sub {
  color: var(--muted);
  font-size:16px;
  max-width:62%;
  margin-bottom:22px;
}
.shown-cta .btn-primary{
  background: linear-gradient(180deg,#2f8eff,#1b6fff);
  color:#fff;
  padding:12px 18px;
  border-radius:10px;
  border:none;
  font-weight:700;
  box-shadow: 0 12px 36px rgba(47,142,255,0.18);
  cursor:pointer;
}

/* RIGHT visual column */
.shown-right {
  position: relative;
  min-height: 420px;
  display:flex;
  align-items:center;
  justify-content:center;
}

/* vertical social column */
.social-col {
  position:absolute;
  left: 6%;
  top: 26%;
  z-index:6;
  display:flex;
  flex-direction:column;
  gap:14px;
  transform: translateZ(0);
}
.social-pill {
  width:54px;
  height:54px;
  border-radius:12px;
  display:flex;
  align-items:center;
  justify-content:center;
  background: linear-gradient(180deg, rgba(255,255,255,0.95), rgba(255,255,255,0.82));
  box-shadow: 0 8px 22px rgba(8,12,24,0.08);
  border: 1px solid rgba(12,20,30,0.03);
  transform-origin:center;
  animation: socialFloat 5.6s ease-in-out infinite;
}
.social-pill img { width:28px; height:28px; object-fit:contain; display:block; }

/* social float variant timings */
.social-pill:nth-child(1){ animation-delay: 0s; }
.social-pill:nth-child(2){ animation-delay: .35s; }
.social-pill:nth-child(3){ animation-delay: .7s; }
.social-pill:nth-child(4){ animation-delay: 1.05s; }
.social-pill:nth-child(5){ animation-delay: 1.4s; }

/* center app icon */
.app-center { position: absolute; left: 34%; top: 40%; z-index:8; transform: translate(-10%, -18%); }
.app-square {
  width:78px;
  height:78px;
  border-radius:18px;
  background: linear-gradient(135deg,#6d4bff,#4cb6ff);
  display:flex;
  align-items:center;
  justify-content:center;
  box-shadow: 0 18px 60px rgba(76,182,255,0.14), 0 6px 18px rgba(109,75,255,0.12);
  position:relative;
  overflow:visible;
}
.app-square img { width:44px;height:44px; display:block; }
.app-glow {
  position:absolute;
  inset:-28px;
  border-radius:20px;
  filter: blur(28px);
  opacity:.9;
  background: radial-gradient(circle, rgba(108,71,255,0.18), rgba(76,182,255,0.06) 45%, transparent 65%);
  pointer-events:none;
}

/* connector line */
.connector {
  position:absolute;
  left:22%;
  top:48%;
  width:12%;
  height:6px;
  background: linear-gradient(90deg,#dfeeff 0%,#8ed1ff 50%, #dfeeff 100%);
  border-radius:4px;
  transform: translate(-16%, -50%);
  z-index:5;
  filter: blur(0.4px);
}

/* CARD WRAP (stack) */
.card-c14s-wrap {
  position: absolute;
  right: 6%;
  top: 18%;
  width: calc(var(--card-c14-w) + 40px);
  height: 380px;
  z-index:9;
  display:block;
  perspective: 1200px;
}

/* base UI card-c14 style (glassmorphism) */
.ui-card-c14 {
  --scale: 1;
  width: var(--card-c14-w);
  border-radius: 14px;
  padding: 14px 14px 18px;
  background: linear-gradient(180deg, rgba(255,255,255,0.78), rgba(255,255,255,0.66));
  border: 1px solid rgba(255,255,255,0.55);
  box-shadow: 0 20px 60px rgba(12,20,28,0.08);
  backdrop-filter: blur(8px) saturate(120%);
  -webkit-backdrop-filter: blur(8px) saturate(120%);
  position: absolute;
  left: 0;
  transform-origin: center;
  transition: transform .28s cubic-bezier(.2,.9,.25,1), box-shadow .28s;
  overflow: hidden;
}

/* individual positions (stacked) */
.card-c14-a { top: 0; transform: translateZ(100px) rotateY(-6deg) translateX(-6%) ; }
.card-c14-b { top: 62px; transform: translateZ(0) rotateY(-2deg) translateX(0%); }
.card-c14-c { top: 136px; transform: translateZ(0) rotateY(6deg) translateX(8%);  }

/* little meta row inside card-c14 */
.card-c14-meta { display:flex; justify-content:space-between; align-items:center; gap:10px; margin-bottom:8px; }
.chip { background: rgba(12,20,28,0.04); color: #0b1320; font-weight:700; padding:6px 10px; border-radius:8px; font-size:13px; }
.mini-chart img { width:56px; height:34px; object-fit:cover; border-radius:8px; }

/* body */
.card-c14-body h4 { margin:0; font-size:16px; font-weight:800; color:#14262e;}
.card-c14-body .muted { color:var(--muted); font-size:13px; margin-top:6px; }

/* CTA inside card-c14 */
.card-c14-cta { margin-top:12px; background: linear-gradient(180deg,#fff 0%, #f3fbff 100%); color:#1b6fff; font-weight:700; padding:8px 12px; border-radius:10px; display:inline-block; box-shadow: inset 0 -3px 0 rgba(27,111,255,0.06); }

/* SLIDE-IN animation (card-c14s enter from right) */
.slide-in {
  opacity: 0;
  transform: translateX(36px) scale(.98);
  animation: slideIn var(--slide-d, 0.6s) cubic-bezier(.2,.9,.25,1) forwards;
  animation-delay: var(--d, 0s);
}

/* float animations (independent) */
.float-slow { animation: floatY 6.4s ease-in-out infinite; }
.float-long { animation: floatY 8.2s ease-in-out infinite; }

/* subtle long float for base */
@keyframes floatY {
  0% { transform: translateY(0) translateZ(0); }
  50% { transform: translateY(-14px) translateZ(0); }
  100% { transform: translateY(0) translateZ(0); }
}

/* slideIn keyframes */
@keyframes slideIn {
  to { opacity:1; transform: translateX(0) scale(1); }
}

/* card-c14 hover lift + tilt */
.ui-card-c14:hover {
  transform: translateY(-8px) scale(1.02) rotateX(0.8deg) rotateY(0deg);
  box-shadow: 0 30px 80px rgba(12,20,28,0.14);
}

/* card-c14 subtle 3D tilt animation (idle) */
.card-c14-a { animation: idleTiltA 6.6s ease-in-out infinite; }
.card-c14-b { animation: idleTiltB 7.8s ease-in-out infinite; }
.card-c14-c { animation: idleTiltC 8.2s ease-in-out infinite; }

@keyframes idleTiltA {
  0% { transform: translateZ(0) rotateY(-6deg) translateX(-6%) translateY(0);z-index:11; }
  50% { transform: translateZ(0) rotateY(-3deg) translateX(-4%) translateY(-8px); }
  100% { transform: translateZ(0) rotateY(-6deg) translateX(-6%) translateY(0); z-index:13;}
}
@keyframes idleTiltB {
  0% { transform: translateZ(0) rotateY(-2deg) translateX(0%) translateY(0);z-index:11; }
  50% { transform: translateZ(0) rotateY(0deg) translateX(0%) translateY(-10px); }
  100% { transform: translateZ(0) rotateY(-2deg) translateX(0%) translateY(0);z-index:13; }
}
@keyframes idleTiltC {
  0% { transform: translateZ(0) rotateY(6deg) translateX(8%) translateY(0); z-index:11;}
  50% { transform: translateZ(0) rotateY(3deg) translateX(6%) translateY(-6px); }
  100% { transform: translateZ(0) rotateY(6deg) translateX(8%) translateY(0);z-index:13; }
}

/* dotted orbit rings under each card-c14 (for visual depth) */
.layer-ring {
  position:absolute; inset:auto; z-index:2;
  border-radius:50%;
  border: 2px dashed rgba(12,20,28,0.06);
  width: calc(var(--card-c14-w) + 120px);
  height: calc(var(--card-c14-w) + 120px);
  left: -58%;
  top: -40%;
  transform: translateZ(-1px);
}

/* SHINY SWEEP on card-c14s and icons: looping */
.shine::after {
  content: "";
  position: absolute;
  inset: -40% -20%;
  background: linear-gradient(120deg,
    rgba(255,255,255,0) 0%,
    rgba(255,255,255,0.22) 42%,
    rgba(255,255,255,0.88) 50%,
    rgba(255,255,255,0.22) 58%,
    rgba(255,255,255,0) 100%);
  transform: translateX(-140%) rotate(12deg);
  mix-blend-mode: screen;
  animation: card-c14Shine 6s linear infinite;
  pointer-events:none;
}
@keyframes card-c14Shine {
  0% { transform: translateX(-160%) rotate(12deg); opacity:0; }
  18% { transform: translateX(-36%) rotate(12deg); opacity:1; }
  40% { transform: translateX(10%) rotate(12deg); opacity:.6; }
  100% { transform: translateX(160%) rotate(12deg); opacity:0; }
}

/* icon social float */
@keyframes socialFloat {
  0% { transform: translateY(0); }
  50% { transform: translateY(-10px) scale(1.02); }
  100% { transform: translateY(0); }
}

/* small tilt for app icon */
.app-square { animation: appTilt 8s ease-in-out infinite; }
@keyframes appTilt {
  0% { transform: rotate(-2deg) translateZ(0); }
  50% { transform: rotate(2deg) translateZ(0); }
  100% { transform: rotate(-2deg) translateZ(0); }
}

/* responsive */
@media (max-width: 980px) {
  .shown-inner { grid-template-columns: 1fr; gap: 32px; }
  .shown-title { font-size:36px; }
  .shown-sub { max-width:100%; }
  .social-col { left:4%; top: 20%; transform: none; display:flex; flex-direction:row; gap:12px; }
  .app-center { left: 50%; top: 36%; transform: translate(-50%,-10%); }
  .card-c14s-wrap { position:relative; right:auto; left:auto; margin: 0 auto; width: 92%; height:auto; top: auto; display:flex; gap:14px; justify-content:center; transform:none; }
  .ui-card-c14 { position:relative; width:320px; left:0; transform:none; box-shadow: 0 18px 40px rgba(12,20,28,0.06); }
  .card-c14-a, .card-c14-b, .card-c14-c { top:0; transform:none; }
  .connector { display:none; }
}

/* smaller phones */
@media (max-width: 520px) {
  .shown-title { font-size:24px; }
  .app-square { width:64px; height:64px; }
  .social-pill { width:44px; height:44px; }
  .ui-card-c14 { width:92%; padding:12px; }
}
        `}</style>
      </section>
    </>
  );
}
